import { render, staticRenderFns } from "./RelationAccount.vue?vue&type=template&id=76075d2d&scoped=true&"
import script from "./RelationAccount.vue?vue&type=script&lang=js&"
export * from "./RelationAccount.vue?vue&type=script&lang=js&"
import style0 from "./RelationAccount.vue?vue&type=style&index=0&id=76075d2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76075d2d",
  null
  
)

export default component.exports